<template>
<section id="questoes">
<Notification ref="notif" :closed="true" corner="bottom-right" />
	<container textButton="ADICIONAR" :pathName="'/questoes/create'" v-if="$auth.user().perfil !== 6"></container>
	<container v-else></container>

	<div class="inner-container">
		<div class="relatorio">
			<router-link :to="{ name: 'ImportacoesQuestoes' }" class="position-left highlight">Importações</router-link>

			<DropdownMenu name="reportMenu"
					text="Parametrizações"
					:items="[
						{ text: 'Cadastrar nível de dificuldade', route: { name: 'nivelDificuldadeCreate' } },
						{ text: 'Cadastrar tipo de questão', route: { name: 'tiposQuestoesCreate' } }
					]"
				/>
			<br style="clear: both" />
		</div>

		<section id="params-container">
			<div id="grid-header"><i class="fas fa-filter"></i>	Filtros:</div>

			<!-- <div id="codigo" class="calendario-container">
				<div class="box-date">
					<input class="input-date" type="text" placeholder="Pesquise pelo código" v-model="params.codigo"/>
					<label for="search"><i class="fas fa-search"></i></label>
				</div>
			</div> -->

			<div id="enunciado" class="search-section">
				<input id="search" type="text" placeholder="Pesquise pelo enunciado" ref="campoparams" v-model.lazy="params.enunciado" @keyup.enter="getQuestoes(1)" />
				<label for="search"><i class="fas fa-search"></i></label>
			</div>

			<div id="codigo">
				<input id="search" type="text" placeholder="Pesquise pelo código" v-model="params.codigo" />
			</div>

			<v-select
				id="curadoria"
				class="area_3"
				v-model="params.curadoria"
				placeholder="Escolha a curadoria"
				@input="populaNextSelect({id: params.curadoria, curr: curadorias,  nextName: 'subCuradorias', prop: 'subCuradorias'})"
				:options="curadorias"
				:reduce="obj => obj.id" label="nome"/>

			<v-select
				id="subcuradoria"
				class="area_3"
				v-model="params.subcuradoria"
				:disabled="subcuradoria"
				placeholder="Escolha a sub curadoria"
				@input="populaNextSelect({id: params.subcuradoria, curr: subCuradorias,  nextName: 'eixos', prop: 'subCuradorias'})"
				:options="subCuradorias"
				:reduce="obj => obj.id" label="nome"/>

			<v-select
				id="eixo"
				class="area_3"
				v-model="params.eixo"
				:disabled="eixo"
				placeholder="Escolha o eixo"
				@input="populaNextSelect({prop: 'subCuradorias'})"
				:options="eixos"
				:reduce="obj => obj.id" label="nome"
			/>

			<v-select id="tipoData" class="tipo area_3" v-model="params.tipoData" placeholder="Escolha a data a ser considerada"
				:reduce="obj => obj.id" label="nome"
				:options="[
							{id: 1, nome:'Apenas data de cadastro'},
							{id: 2, nome:'Apenas data de atualização'}
						]"
			/>

			<div id="dataInicio" class="calendario-container data">
				<div class="box-date">
					<datepicker class="input-date" :clear-button="true"
					placeholder="Selecione a data inicial" :language="calendarLanguage.ptBR" format="dd/MM/yyyy"
					v-model="params.dataInicio"></datepicker>
					<i class="far fa-calendar-alt"></i>
				</div>
			</div>

			<div id="dataFim" class="calendario-container datafim">
				<div class="box-date">
					<datepicker class="input-date" :clear-button="true"
					placeholder="Selecione a data final" :language="calendarLanguage.ptBR" format="dd/MM/yyyy"
					v-model="params.dataFim"></datepicker>
					<i class="far fa-calendar-alt"></i>
				</div>
			</div>

			<v-select
				id="tema"
				class="area_4"
				:disabled="tema"
				v-model="params.tema"
				placeholder="Escolha o objeto"
				:options="temas"
				:reduce="el => el.id" label="titulo"
			/>

			<v-select
				id="tipoQuestao"
				v-model="params.tipoQuestao"
				placeholder="Escolha o tipo de questão"
				:options="tiposQuestao"
				:reduce="el => el.id" label="descricao"
			/>

			<v-select
				id="statusQuestao"
				v-model="params.statusQuestao"
				placeholder="Escolha o status da questão"
				:options="[
					{ id: 1, nome: 'FINALIZADO' },
					{ id: 2, nome: 'PENDENTE' },
					{ id: 3, nome: 'PREENCHIMENTO PENDENTE' }
				]"
				:reduce="el => el.id" label="nome"
			/>

			<v-select
				id="dificuldade"
				v-model="params.dificuldade"
				placeholder="Escolha o nível de dificuldade"
				:options="niveisDificuldade"
				:reduce="el => el.id" label="descricao"
			/>

			<div class="acoes">
				<button type="button" class="btn" id="exportar" @click="questionReport" >Exportar questões com os filtros selecionados <span class="download-status question"></span></button>
				<button type="button" class="btn" id="limpar" @click="limparFiltros(), getQuestoes(2)">Limpar</button>
				<button type="button" class="btn" id="filtrar" @click="getQuestoes(2)">Filtrar</button>
			</div>

		</section>

		<load-content v-if="loadContent" />
		<div class="table-wrapper" v-if="!loadContent && questoes.length > 0">
			<div class="table">
				<table>
					<thead>
						<tr>
							<!--<th id="th-codigo" class="ordena">Código<i class="fas fa-arrow-up"></i></th>-->
							<th id="th-codigo">Código</th>
							<th id="th-nome" class="ordena">Enunciado<!--<i class="fas fa-arrow-up"></i>--></th>
							<th id="th-acoes">Ações</th>
						</tr>
					</thead>

					<tbody>
						<tr class="fields" v-for="questao in questoes" :key="questao.id">
							<td class="questao-codigo">
								<span class="code-error" v-if="getCode(questao, true).error">{{ getCode(questao, true).msg }}</span>
								<span v-else>{{ getCode(questao, true) }}</span>
							</td>
							<td class="questao-nome"><span>{{ HTMLStrip(questao.enunciado) }}</span></td>
							<td class="acoes">
								<div class="btn-container">
									<span class="copy-id-obj">
										<copiar :button="true" :text="questao.id" :hideText="true"></copiar>
									</span>
									<item-edit v-if="$auth.user().perfil !== 6" class="editar acao" :routerName="'questoesEdit'" :params="{ id: questao.id  }" :active="true" />
									<router-link class="visualizar acao" :to="{ name: 'questoesDetails', params: { id: questao.id }}">
										<i class="far fa-eye"></i>
									</router-link>
									<button-remove v-if="$auth.user().perfil !== 6" class="acao" :onClick="() => selectHandler(questao)" :active="true" />
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="paginacao" v-if="totalItens > 20">
				<Pagination :totalItens="totalItens" :currentPage="currentPage" @pagina="getCurrentPage" />
			</div>
		</div>
		<div v-else-if="!loadContent && inicial" class="objectNotFound">
				Nenhuma questão encontrada :)
		</div>

		<!-- Modal para confirmação de exclusão de área de conhecimento -->
		<Modal v-show="isModalVisible" @close="() => this.isModalVisible = !this.isModalVisible">
			<template v-slot:body>
				<p class="texto">Deseja remover a questão? <br /> <span v-html="removeItem.enunciado"></span></p>
			</template>

			<template v-slot:footer>
				<button-action type="button" :onClick="() => remove(removeItem.id, removeItem.curadoriaId)" class="xs danger" style="margin-right: 10px;">Confirmar</button-action>
				<button-action type="button" :onClick="closeModal" class="xs default">Cancelar</button-action>
			</template>
		</Modal>
		<!-- Final exclusão de área de conhecimento  -->

		<!-- Modal para confirmação de exclusão de área de conhecimento -->
	</div>
</section>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { ptBR } from 'vuejs-datepicker/dist/locale'
import { questoes } from '@/services/questoes'
import { curadoria } from '@/services/curadoria'
import { objetos } from '@/services/objetos'
import { tipoQuestao } from '@/services/tipoQuestao'
import { nivelDificuldade } from '@/services/nivelDificuldade'

import { HTMLStrip } from '@/helpers/HTMLStrip'
import { getCode } from '@/helpers/questionCode'

import vSelect from 'vue-select'
import Pagination from '@/components/shared/Pagination'
import container from '@/components/shared/Container'
import LoadContent from '@/components/shared/LoadContent'
import Modal from '@/components/shared/Modal'
import ButtonAction from '@/components/shared/ButtonAction'
import ButtonRemove from '@/components/shared/ButtonRemove'
import ItemEdit from '@/components/shared/ItemEdit'
import Copiar from '@/components/shared/Copiar'
import DropdownMenu from '@/components/shared/DropdownMenu'

export default {
	name: 'questoesList',
	components: { container, Modal, ButtonAction, ButtonRemove, ItemEdit, Pagination, LoadContent, vSelect, Datepicker, Copiar, DropdownMenu },
	data () {
		return {
			calendarLanguage: { ptBR },
			questoes: [],
			totalItens: 0,
			currentPage: 1,
			isModalVisible: false,
			removeItem: {},
			params: {
				dataInicio: '',
				dataFim: '',
				codigo: '',
				tema: '',
				curadoria: '',
				subcuradoria: '',
				eixo: '',
				enunciado: '',
				tipoData: 1,
				dificuldade: '',
				tipoQuestao: '',
				status: ''
			},
			isModalVisibleDetalhes: false,
			inicial: false,
			subcuradoria: true,
			eixo: true,
			tema: true,
			usuario: '',
			loadContent: false,
			curadorias: [], // TODO Filtrar curadoria de acordo com o curador selecionado ou vice-versa [Seria realmente útil?]
			subCuradorias: [],
			eixos: [],
			temas: [],
			tiposQuestao: [],
			niveisDificuldade: []
		}
	},
	async created () {
		// const PERFIL_CURADOR = 2
		// this.inicial = true
		// this.params.usuario = this.$auth.user().id
		this.getCurrentPage()
		window.addEventListener('keydown', this.focusparams)

		await Promise.all([curadoria.findByActiveInTree(), tipoQuestao.find(), nivelDificuldade.find()]).then(res => {
			this.curadorias = res[0].data
			this.tiposQuestao = res[1].data
			this.niveisDificuldade = res[2].data
		}).catch(err => console.log(err))
	},
	methods: {
		HTMLStrip (str) {
			return HTMLStrip(str).substring(0, 150) + '...'
		},
		getCode,
		async getCurrentPage () {
			this.loadContent = true
			this.params.skip = this.$route.query.skip

			if (this.params && this.params.skip) {
				this.currentPage = parseInt(this.params.skip)
				this.params.skip = parseInt(this.params.skip) - 1
			} else {
				this.currentPage = 1
				this.params.skip = 0
			}

			this.questoes = []

			await questoes.find(this.params)
				.then(res => {
					this.questoes = res.data
					this.totalItens = res.data[0].totalDeQuestoes
					this.inicial = true
					return this.questoes
				})
				.catch(err => console.log(err))

			this.loadContent = false
		},
		closeModal () {
			this.isModalVisible = false
		},
		selectHandler (data) {
			this.isModalVisible = true
			this.removeItem = data
		},
		async getQuestoes (identificador) {
			this.loadContent = true
			this.params.skip = 0
			let retorno = {}
			try {
				if (identificador === 1 && this.params.texto !== undefined) {
					retorno = await questoes.find(this.params)
				} else {
					retorno = await questoes.find(this.params)
				}
				if (this.usuario) {
					this.params.dono = this.usuario.id
				}

				this.questoes = retorno.data
				this.totalItens = retorno.data[0].totalDeQuestoes
				this.paginaAtual = 1
			} catch (error) {
				console.log('error', error)
			}
			this.loadContent = false
		},
		quantidadeFiltros () {
			let quantidade = 0
			Object.keys(this.params).forEach((key) => {
				if (this.params[key] !== '') {
					quantidade++
				}
				// console.log(this.params[key])
			})
			return quantidade
		},
		async remove (id, curadoriaId) {
			this.isModalVisible = false
			this.loadContent = true
			try {
				await questoes.delete(id, curadoriaId)
				// this.questoes = this.questoes.filter(questao => questao.id !== id)
				if (parseInt(this.removeItem.totalDeQuestoes - 1) % 20 === 0) {
					const query = { skip: this.$route.query.skip - 1 }
					this.$router.replace({ query })
					this.params.skip = this.$route.query.skip > 1 ? this.$route.query.skip - 1 : 0
				}
				const questoesRetorno = await questoes.find(this.params)
				this.objetos = questoesRetorno.data

				if (this.objetos.length) {
					this.totalItens = questoesRetorno.data[0].totalDeQuestoes
				}

				window.notificationEM.open('', 'Questão removida com sucesso!', 'success')
			} catch (error) {
				if (error.response.status === 400) {
					window.notificationEM.open('', `${error.response.data.msg}`, 'error')
				} else {
					window.notificationEM.open('', 'Ocorreu um erro, tente novamente!', 'error')
				}
			}
			this.removeItem = {}
			this.loadContent = false
		},
		focusparams () {
			if (event.keyCode === 13 && event.target.id !== 'search' && this.$refs.campoparams) {
				this.$refs.campoparams.focus()
			}
		},
		async userSearch (user) {
			this.params.dono = ''
			this.params.curadoria = ''
			this.params.subcuradoria = ''
			this.params.eixo = null
			this.eixo = true
			this.subcuradoria = true
			if (user) {
				this.params.dono = user.id
				await curadoria.findByUser({ id: user.id, perfil: user.perfil })
					.then(res => {
						this.curadorias = res.data
					})
					.catch(err => console.log(err))
			} else {
				await curadoria.findByActiveInTree()
					.then(res => {
						this.curadorias = res.data
					})
					.catch(err => console.log(err))
			}
		},
		async populaNextSelect (param = {}) {
			this.temas = []
			this.params.tema = this.params.tema === null ? '' : null
			if (param.nextName === 'subCuradorias') {
				this.params.subcuradoria = null
				this.params.eixo = null
				if (param.id) {
					this.subcuradoria = false
				} else {
					this.subcuradoria = true
				}
				this.eixo = true
				this.subCuradorias = []
				this.eixos = []
			}
			if (param.nextName === 'eixos') {
				this.eixo = !this.eixo
				this.params.eixo = this.params.eixo === null ? '' : null
				this.eixos = []
			}
			if (param.id) {
				const obj = param.curr.find(c => c.id === param.id)
				this[param.nextName] = obj[param.prop]
			}
			const data = {
				tipos: this.tipo,
				curadoria: this.params.curadoria,
				subcuradoria: this.params.subcuradoria,
				eixo: this.params.eixo
			}
			if (data.curadoria) {
				this.tema = false
				const retorno = await objetos.find(data, false)
				this.temas = retorno.data
			} else {
				this.temas = []
				this.params.tema = null
			}
		},
		detalhesQuestoes () {
			this.isModalVisibleDetalhes = true
		},
		async questionReport () {
			if (parseInt(this.quantidadeFiltros()) < 3) {
				window.notificationEM.open('', 'É necessário selecionar pelo menos dois itens dos filtros!', 'warning')
				return
			}

			if (this.params.dataInicio && this.params.dataFim && this.params.dataInicio > this.params.dataFim) {
				window.notificationEM.open('', 'A data inicial não pode ser menor que a data final', 'warning')
				return
			}

			document.querySelector('.download-status.question').classList.add('downloading')
			const reportRequest = await questoes.processReport(this.params)
			document.querySelector('.download-status.question').classList.remove('downloading')

			location.href = reportRequest.data.arquivo
		},
		limparFiltros () {
			let i = 0
			for (i in this.params) {
				this.params[i] = ''
				this.params.skip = 0
				this.params.currentPage = 1
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.inner-container {
	position: relative;
	z-index: 1;
	padding: 20px;
	margin-top: -60px;
	border-radius: 10px;
	background-color: #FFF;
}

#params-container {
	color: #FFF;
	background-color: $main-color;
	border-radius: 4px;
	margin-top: 15px;
	height: 100%;
	width: 100%;
	padding: 5px 10px 10px;

	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-template-areas: "header header header"
						"enunciado enunciado codigo"
						"tipoData dataInicio dataFim"
						"curadoria subcuradoria eixo"
						"tema tema tema"
						"tipoQuestao statusQuestao dificuldade"
						"acoes acoes acoes";

	align-items: center;
	gap: 10px;

	#grid-header { grid-area: header }
	#enunciado { grid-area: enunciado }
	#codigo { grid-area: codigo }
	#tipoData { grid-area: tipoData }
	#dataInicio { grid-area: dataInicio }
	#dataFim { grid-area: dataFim }
	#curadoria { grid-area: curadoria }
	#subcuradoria { grid-area: subcuradoria }
	#eixo { grid-area: eixo }
	#tema { grid-area: tema }
	#tipoQuestao { grid-area: tipoQuestao }
	#statusQuestao { grid-area: statusQuestao }
	#dificuldade { grid-area: dificuldade }
	.acoes { grid-area: acoes }

	#curadoria, #subcuradoria, #eixo, #tema, #tipoData, #dataInicio, #dataFim {
		width: 100%;
		height: 45px;
	}

	#grid-header{
		position: relative;
		top: 5px;
		font-family: $font-family;
		font-size: $font-size;
		font-weight: $font-weight-labels;
	}

	.search-section{
		background-color: #ffffff;
		height: 45px;
		margin-left: 0px;
		margin-top: 0px;
		padding: 16px 16px 16px 10px;

		#search{
			margin-left: 0px;
		}

		label {
			color: #808080;
			i {
				font-weight: 600;
				position: relative;
				top: 1px;
				left: 8px;
			}
		}

	}

	#codigo {
		height: 100%;
		min-height: 45px;

		input {
			width: 100%;
			height: 100%;
			padding: 10px;
			border: none;
			border-radius: $border-radius;
			background-color: #FFF;
		}
	}

	.v-select {
		height: 100%;
		min-height: 45px;
		background-color: white;
		border-radius: 4px;
		border:none;
	}

	.vs__fade-enter-active,
	.vs__fade-leave-active {
		transition: none;
	}

	#dataInicio, #dataFim {
		background-color: #ffffff;
		height: 45px;
		border-radius: 5px;
		padding: 0px 5px;
		display: flex;

		&.calendario-container {
			.box-date {
				width: 100%;
				i {
					position: relative;
					top: -35px;
					left: 6px;
					color: gray;
					font-size: 25px;
				}
			}
		}
	}

	.acoes {
		display: grid;
		grid-template-columns: 5fr 1fr 1fr;
		gap: 5px;
		margin-top: 20px;

		.btn {
			justify-self: end;
			width: 140px;
			height: 45px;
			padding: 20px 0;
			border: none;
			border-radius: 4px;
			outline: none;
			line-height: 1px;
			background-color: $success-color;
			color: #fff;
			font-weight: $font-weight-buttons;
			font-size: $font-size-button;
			font-family: "Roboto",Condensed,sans-serif;
			text-transform: uppercase;
			cursor: pointer;
			transition: background-color .127s;

			&#limpar {
				background-color: transparent;
				border: 1px solid #FFF;

				&:hover {
					background-color: #FFF2;
				}
			}

			&#exportar {
				justify-self: start;
				width: fit-content;
				padding: 15px;
				font-size: .825em;
			}

			&:hover {
				background-color: #2E5BBD;
			}
		}
	}

	.params-container-row {
		background-color: yellow;
		height: 45px;
	}
}

#questoes {
	.table-wrapper {
		.table {
			position: relative;
			display:flex;
			padding: 5px 0px 5px;
			color: $main-color;
			font-weight: $font-weight-default-bolder;

			thead{
				th{
					&.ordena {
						i {
							margin-left: 5px;
							font-size: 12px;
							font-weight: 600;
						}
					}
					&#th-nome {
						text-align: left;
					}
				}
			}

			tbody {
				.fields {
					height: 45px;
					background-color: $inputs-color;
					td {
						vertical-align: middle;
						font-size: 0.9em;
						flex-grow: 0;
						color: gray;
						font-weight: 500;

						.code-error {
							font-size: .9em;
							font-weight: bold;

							&::before {
								content: '!';
								display: inline-flex;
								justify-content: center;
								align-items: center;
								width: 26px;
								height: 26px;
								margin-right: 10px;
								border-radius: 50%;
								background-color: #FFBB00;
								color: #FFF;
							}
						}
					}
					.questao-codigo {
						width: 16%;
					}
					.questao-nome {
						width: 55%;
						text-align: left;
						word-wrap: anywhere;
					}
					.questao-tipo {
						text-align: center;
						&.text-overflow {
							min-width: 75px;
							max-width: 162px;
							text-align: center;
							text-overflow: ellipsis;
							white-space: nowrap;
							overflow: hidden;
						}
						span {
							background-color: #fff;
							padding: 5px 20px;
							border-radius: 4px;
						}
					}
					.questao-update {
						text-align: center;
					}
				}
			}
		}
	}
}

.objectNotFound {
	margin-top: 50px;
	color: #000;
	text-align: center;
}
</style>

<style lang="scss">
img {
	max-width: 100%;
}

.vs--searchable .vs__dropdown-toggle {
	height: 100%;
}

.vdp-datepicker {
	border:none !important;
	height: 100%;
	width: 100%;
	color: gray;
	div:first-of-type {
		height: 100%;
		input[type=text] {
			width: 100%;
			height: 100%;
			text-align: left;
			border: none;
			font-family: $font-family;
			font-weight: $font-weight-input-bolder;
			font-size: $font-size;
			color: $font-color;
			padding-left: 35px;
			&:focus{
				outline-color: transparent;
			}
		}
	}
	.vdp-datepicker__clear-button {
		position: absolute;
		right: 10px;
		top: 5px;
		i {
			font-size: 30px;
		}
	}
}
.vs--searchable .vs__dropdown-toggle {
	height: 100%;
}
</style>
